import { UserInfoService } from '@appStore/account/services/user-info.service';
import { NotificationService } from '@appStore/account/services/notification.service';
import { SettingsService } from '@appStore/account/services/settings.service';
import { MessagesService } from '@appStore/account/services/messages.service';
import { WidgetService } from '@appStore/account/services/widget.service';
import { UserNotificationSettingsService } from '@appStore/account/services/user-notification-settings.service';

export const services: any[] = [
  UserInfoService,
  NotificationService,
  SettingsService,
  MessagesService,
  WidgetService,
  UserNotificationSettingsService,
];

export * from '@appStore/account/services/user-info.service';
export * from '@appStore/account/services/notification.service';
export * from '@appStore/account/services/settings.service';
export * from '@appStore/account/services/messages.service';
export * from '@appStore/account/services/widget.service';
export * from '@appStore/account/services/user-notification-settings.service';
